import { Parser } from 'json2csv'

class JsonToCsv {
  json: { header: {}; body: Array<any>; info: any }

  constructor(json: { header: {}; body: Array<any>; info: any }) {
    this.json = json
  }

  info() {
    const info = this.json.info ?? []
    info.map((item: any) => {
      Object.keys(this.json.header).map((key: any) => {
        if (!(key in item)) {
          item[key] = ''
        }
      })
    })
    return info
  }

  fetch() {
    const fields: any = Object.keys(this.json.header)
    const json2csvParser = new Parser({ fields, header: false })
    return json2csvParser.parse([...this.info(), this.json.header, ...this.json.body])
  }
}

export default JsonToCsv
